<template>
	<div>
		<k-modal
			id="responseRequirementModal"
			:title="$t('modals.titles.requirementResponse')"
			size="xl"
			:okTitle="okBtnText"
			:cancelTitle="cancelBtnText"
			:customClass="modalClass"
			:okVariant="okVariant"
			:okDisabled="!validateOk"
			:cancelVariant="cancelVariant"
			:okOnly="okOnly"
			@ok="okEvent"
			@hidden="clearModalData"
			@cancel="cancelEvent"
			@beforeHide="hideEvent"
		>
			<template v-slot:content>
				<b-row class="details mt-2">
					<div class="basicInformations">
						<label>{{ $t("commons.requirementName") }}</label> {{ requirement.description }}
					</div>
					<div class="basicInformations">
						<label>{{ $t("commons.requirementType") }}</label> {{ requirementType }}
					</div>
					<div class="textModal">
						<label
							><strong>{{ $t("commons.explanation") }}</strong></label
						>
						<div class="formatted-text-display">
							{{ requirement.explanation }}
						</div>
					</div>
				</b-row>
				<hr />

				<h5 class="ml-3" v-if="requirement.isIntegration">{{ $t("modals.responseRequirement.queryReturn") }}</h5>
				<p class="ml-3" v-if="modalType == 'reprocess' || reprocess">
					{{ netrinMessageError }}
				</p>
				<!-- Integration Section -->
				<section
					v-if="requirement.isIntegration && includedIntegrationRequirementResponse != requirement.idIntegration"
				>
					<b-row v-if="!integrationIsArray && !reprocess" class="details mt-2">
						<div
							class="basicInformations"
							v-for="prop in integrationProps.filter((ip) => integration[ip] !== '')"
							v-bind:key="prop"
						>
							<label>{{ $t(`commons.integrationConsultations.${prop}`) }} &nbsp;</label>
							<a v-if="integration[prop] === integration.urlProof"></a>
							<a v-else>{{
								integration[prop] === true
									? $t("commons.boolean.true")
									: integration[prop] === false
									? $t("commons.boolean.false")
									: integration[prop]
							}}</a>
						</div>

						<div class="basicInformations" v-if="integrationURLProofAvailable">
							<div class="download-section">
								<label>{{ $t("commons.integrationConsultations.urlProof") }}</label>
								<div class="download-button-container">
									<k-icon-button
										icon="download"
										variant="secondary"
										v-on:click="goToSite(integration.urlProof)"
										:title="$t('modals.responseRequirement.receiveDownload')"
										:textTooltip="$t('commons.hovers.downloadFile')"
										class="mr-2"
									/>
									<a>{{ $t("modals.responseRequirement.downloadReceive") }}</a>
								</div>
							</div>
						</div>

						<div v-else-if="shouldShowURLProofMessage">
							<a>{{ $t("modals.responseRequirement.notGeneratedURLProof") }}</a>
						</div>
					</b-row>
					<b-row v-if="integrationIsArray && !reprocess" class="details mt-2 d-block">
						<div class="separator" v-for="integrationItem in integrationArray" v-bind:key="integrationItem.itemId">
							<div class="basicInformations" v-for="prop in getProperties(integrationItem)" v-bind:key="prop">
								<label>{{ $t(`commons.integrationConsultations.${prop}`) }} &nbsp;</label>
								<a v-if="integrationItem[prop] === integrationItem.urlProof"></a>
								<a v-else>{{
									integrationItem[prop] === true
										? $t("commons.boolean.true")
										: integrationItem[prop] === false
										? $t("commons.boolean.false")
										: integrationItem[prop]
								}}</a>
							</div>
						</div>
						<div class="basicInformations" v-if="integration.length > 0 && integration[0].urlProof">
							<div class="download-section">
								<label>{{ $t("commons.integrationConsultations.urlProof") }}</label>
								<div class="download-button-container">
									<k-icon-button
										icon="download"
										variant="secondary"
										v-on:click="goToSite(integration[0].urlProof)"
										:title="$t('modals.responseRequirement.receiveDownload')"
										textTooltip="Fazer download do arquivo"
										class="mr-2"
									/>
									<a>{{ $t("modals.responseRequirement.downloadReceive") }}</a>
								</div>
							</div>
						</div>
					</b-row>
				</section>
				<!-- Integration Requirement Response Section -->
				<section v-show="includedIntegrationRequirementResponse == requirement.idIntegration">
					<b-row
						v-if="requirement.isIntegration && !integrationRequirementResponseIsArray && !reprocess"
						class="details mt-2"
					>
						<div
							class="basicInformations"
							v-for="prop in integrationRequirementResponseProps.filter(
								(ip) => visibleIntegrationRequirementResponse[ip] !== ''
							)"
							v-bind:key="prop"
						>
							<label>{{ $t(`commons.integrationConsultations.${prop}`) }} &nbsp;</label>
							<a>{{
								visibleIntegrationRequirementResponse[prop] === true
									? this.$t("commons.boolean.true")
									: visibleIntegrationRequirementResponse[prop] === false
									? this.$t("commons.boolean.false")
									: visibleIntegrationRequirementResponse[prop]
							}}</a>
						</div>
						<b-button
							v-show="!visibleIntegrationRequirementResponse.answer"
							class="bi bi-download button-with-tooltip"
							@click="generatePDF"
							v-b-tooltip.hover.hover="{
								title: $t('modals.responseRequirement.downloadFile'),
								customClass: 'custom-tooltip',
								placement: 'right'
							}"
							><b-icon icon="download" class="mr-2" />{{
								$t(`commons.integrationConsultations.integrationRequirementResponsePDFButton`)
							}}</b-button
						>
					</b-row>
				</section>
				<b-row v-if="requirement.fileId && !reprocess">
					<b-col cols="12" class="modalPadding">
						<b-form-group :label="$t('commons.requirementAttachment')" label-for="group-filename">
							<b-input-group id="group-filename">
								<b-form-input :value="documentRequirement.fileName" disabled class="b-0"></b-form-input>
								<b-input-group-append>
									<k-icon-button
										icon="download"
										variant="secondary"
										@click="downloadRequirementFile(documentRequirement.id)"
										:textTooltip="$t('commons.hovers.downloadFile')"
									/>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>

				<div class="basicInformations" v-if="!requirement.isIntegration">
					<response-requirement-form
						:mappedQuestionsWithConditions="mappedQuestionsWithConditions"
						:requirementQuestionData="requirementQuestionData"
						:modalType="modalType"
						:displayType="displayType"
						@blur="handleBlur"
						@fieldChange="handleFieldChange"
					></response-requirement-form>
				</div>

				<k-crud ref="requirementCRUD" :fields="requirementResponseCrudStructure" :data="requirementResponseData" />

				<div>
					<b-row
						v-if="
							modalType == $requirementResponseModalType.requirementResponse &&
							(requirement.hasAttachment || displayType === $displayType.TABLE)
						"
					>
						<input id="upload-file" ref="uploadInput" multiple="multiple" type="file" @change="uploadFiles" hidden />
						<b-col cols="12" class="modalPadding">
							<b-form-group
								:label="$t('commons.attachment') + `${requirement.isAttachmentMandatory ? ' *' : ''}`"
								label-for="group-filename"
							>
								<b-input-group id="group-filename">
									<b-form-input :value="fileInputText" disabled class="b-0"></b-form-input>
									<b-input-group-append>
										<k-icon-button
											icon="upload"
											variant="secondary"
											@click="triggerUpload()"
											:textTooltip="$t('commons.hovers.uploadFile')"
											class="downloadButton"
										/>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
				</div>

				<div>
					<div :key="filesListKey" v-if="modalType == $requirementResponseModalType.requirementResponse">
						<div class="fileListReadOnly" v-for="(file, idx) in fileName" v-bind:key="idx + 10">
							<div class="fileLine">
								<b-icon :tooltip="$t('commons.attachment')" icon="file-earmark" class="icon" />
								<div>{{ file.name }}</div>
								<k-icon-button
									name="deleteButton"
									variant="outline-danger"
									class="float-inherit"
									icon="x"
									@click="removeFileInput(idx)"
									:textTooltip="$t('buttons.erase')"
								/>
							</div>
						</div>
					</div>
					<div
						:key="localFilesListKey"
						class="mx-3 mt-4"
						v-if="localFilesMap[responseIndex] && localFilesMap[responseIndex].length > 0"
					>
						<b-form-group :label="$t('commons.localFiles')">
							<div
								v-for="(file, index) in localFilesMap[responseIndex]"
								v-bind:key="localFilesListKey + '-' + index"
								class="d-flex align-items-center justify-content-between mb-2"
							>
								<div class="d-flex align-items-center">
									<b-icon icon="file-earmark-plus" class="mr-2 text-success" />
									<span>{{ file.name }}</span>
								</div>
								<k-icon-button
									name="deleteButton"
									variant="outline-danger"
									class="float-inherit"
									icon="x"
									:disabled="modalType != $requirementResponseModalType.requirementResponse"
									@click="removeLocalFile(index)"
									:textTooltip="$t('buttons.erase')"
								/>
							</div>
						</b-form-group>
					</div>

					<div :key="filesListKey" v-if="modalType != $requirementResponseModalType.requirementResponse">
						<span class="fileTitle" v-if="fileName.length > 0">{{ $t("commons.attachments") }}</span>
						<div class="fileList" v-for="(file, idx) in fileName" v-bind:key="idx + 20">
							<div class="fileLine" @click="downloadResponseFile(file.idDocument)">
								<b-icon
									icon="download"
									class="icon"
									v-b-tooltip:[hover]="{
										title: $t('commons.hovers.downloadFile'),
										customClass: 'custom-tooltip',
										interactive: false,
										placement: 'bottom'
									}"
								/>
								<div>{{ file.name }}</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer="{}">
				<b-button
					:disabled="!validateReevaluate"
					variant="outline-info"
					v-if="modalType == $requirementResponseModalType.clientValidation && displayType != $displayType.TABLE"
					@click="reevaluateEvent"
					>{{ $t("buttons.reevaluate") }}</b-button
				>
				<b-button
					variant="outline-info"
					v-if="modalType == $requirementResponseModalType.reprocess"
					@click="reprocessEvent"
				>
					{{ $t("buttons.tryAgain") }}
				</b-button>
				<b-button :variant="cancelVariant" @click="cancelEvent">{{ cancelBtnText }}</b-button>
				<b-button
					v-if="shouldShowPartialSavingButton"
					variant="info"
					@click="okEvent(true)"
					:disabled="!validatePartial"
				>
					{{ $t("buttons.savePartial") }}
				</b-button>
				<b-button :variant="okVariant" @click="okEvent(false)" :disabled="!validateOk">{{ okBtnText }}</b-button>
			</template>
		</k-modal>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import KModal from "./KModal.vue";
import KCrud from "../ui/KCrud.vue";
import KIconButton from "../ui/Buttons/KIconButton.vue";
import ResponseRequirementForm from "../requirement/ResponseRequirementForm.vue";
import ModalMixin from "@/mixins/ModalMixin";
import ValidityMixin from "@/mixins/ValidityMixin";
import ConditionQuestionMixin from "@/mixins/ConditionQuestionMixin";
import RequirementQuestionValidationMixin, { RequirementVerifier } from "@/mixins/RequirementQuestionValidationMixin";
import RequirementQuestionPersistenceMixin from "@/mixins/RequirementQuestionPersistenceMixin";
import RequirementResponseMapperMixin from "@/mixins/RequirementResponseMapperMixin";
import jsPDF from "jspdf";

const noIncludedItegrationProps = ["idSupplier", "itemId", "id", "urlProof"];

export default {
	components: {
		KModal,
		KCrud,
		KIconButton,
		ResponseRequirementForm
	},
	mixins: [
		ModalMixin,
		ValidityMixin,
		ConditionQuestionMixin,
		RequirementQuestionValidationMixin,
		RequirementQuestionPersistenceMixin,
		RequirementResponseMapperMixin
	],
	data() {
		let idInvite = 0;
		let idRequirement = 0;
		let reprocess = false;
		let idStep = 0;
		let idClient = 0;

		let modalCancelConfirmConfigs = {
			message: this.$t("modals.responseRequirement.modals.cancelConfirm.message"),
			title: this.$t("modals.responseRequirement.modals.cancelConfirm.title"),
			okTitle: this.$t("buttons.reject"),
			cancelTitle: this.$t("buttons.cancel")
		};
		let modalType = this.$requirementResponseModalType.anyView;
		let fileInputs = [""];
		let deletedFilesId = [];
		let fileInputText = this.$t("commons.placeholders.uploadFile");
		let filesListKey = 0;
		return {
			idInvite,
			idRequirement,
			reprocess,
			idStep,
			idClient,
			messageAction: this.$t("modals.responseRequirement.cancelInviteRejectReason"),
			modalCancelConfirmConfigs,
			modalType,
			fileInputs,
			deletedFilesId,
			fileInputText,
			filesListKey,
			requirementResponseData: {
				issueDate: null,
				validityDate: "",
				answer: null,
				identifier: null,
				userConfirm: null,
				attach: [],
				scoreValue: 0,
				observation: null,
				description: null
			},
			fileName: [],
			localFiles: [],
			localFilesMap: {},
			localFilesListKey: 0,
			requirementQuestionData: [],
			questions: [],
			loadingValidation: true,
			allFieldsValid: true,
			mappedQuestionsWithConditions: [],
			validateFile: false,
			isFillerValidatorOnReevaluation: false,
			isValidateActor: false,
			addedFile: false,
			displayType: null,
			tableAnswersToEdit: [],
			netrinMessageError: "",
			responseIndex: 0
		};
	},
	computed: {
		...mapGetters([
			"requirementWithInactivatedQuestions",
			"integration",
			"document",
			"documentRequirement",
			"requirementResponse",
			"documentRequirementResponse",
			"userPermissions",
			"requirementResponseConditionList",
			"integrationRequirementResponse",
			"visibleIntegrationRequirementResponse",
			"actualUser",
			"configurations"
		]),
		integrationURLProofAvailable() {
			const notGeneratedURLProof = "Não conseguimos gerar o link do comprovante.";
			return this.integration?.urlProof && this.integration?.urlProof != notGeneratedURLProof;
		},
		shouldShowURLProofMessage() {
			return this.integration?.urlProof !== undefined && !this.integrationURLProofAvailable;
		},
		shouldShowPartialSavingButton() {
			return (
				this.configurations.PartialSaving &&
				this.shouldShowButton &&
				this.modalType != this.$requirementResponseModalType.anyView
			);
		},
		shouldShowButton() {
			return (
				(this.questions.some(({ formType }) => formType === this.$FormType.ValidationForm) &&
					this.modalType === this.$requirementResponseModalType.clientValidation) ||
				this.modalType === this.$requirementResponseModalType.requirementResponse
			);
		},
		requirement() {
			return this.requirementWithInactivatedQuestions;
		},
		includedIntegrationRequirementResponse() {
			return [Vue.prototype.$IncludedIntegrationRequirementResponse.SERASA];
		},
		integrationIsArray: function () {
			return Array.isArray(this.integration) ?? false;
		},
		integrationRequirementResponseIsArray: function () {
			return Array.isArray(this.integrationRequirementResponse) ?? false;
		},
		integrationArray: function () {
			let array = [];
			if (!Array.isArray(this.integration)) return array;

			for (let index = 0; index < this.integration.length; index++) {
				const element = {
					itemId: index,
					...this.integration[index]
				};
				array.push(element);
			}
			return array;
		},
		integrationProps: function () {
			if (this.integration && !Array.isArray(this.integration)) {
				return Object.keys(this.integration).filter((prop) => noIncludedItegrationProps.indexOf(prop) == -1);
			}
			return [];
		},
		integrationRequirementResponseProps() {
			if (this.visibleIntegrationRequirementResponse && !Array.isArray(this.visibleIntegrationRequirementResponse)) {
				if (this.visibleIntegrationRequirementResponse) return Object.keys(this.visibleIntegrationRequirementResponse);
			}
			return [];
		},
		modalTitle: function () {
			switch (this.$requirementResponseModalType) {
				case this.$requirementResponseModalType.requirementResponse:
					return this.$t("modals.responseRequirement.title.response");
				case this.$requirementResponseModalType.anyView:
					return this.$t("modals.titles.requirementResponse");
				case this.$requirementResponseModalType.clientValidation:
					return this.$t("modals.responseRequirement.title.validation");
			}
			return "";
		},
		okVariant: function () {
			const verifier = new RequirementVerifier(this.requirement, this.requirementResponseData);
			if (verifier.verifyOkVariant(this.modalType, this.displayType)) return "info";
			return "primary";
		},
		cancelVariant: function () {
			const isRequirementResponseModal = this.modalType == this.$requirementResponseModalType.requirementResponse;
			const isTableValidation =
				this.modalType == this.$requirementResponseModalType.clientValidation &&
				this.displayType == this.$displayType.TABLE;
			if (isRequirementResponseModal || isTableValidation) return "outline-info";
			return "secondary";
		},
		validateOk() {
			const verifier = new RequirementVerifier(this.requirement, this.requirementResponseData);
			if (
				this.modalType == this.$requirementResponseModalType.requirementResponse &&
				this.requirementResponseData?.attach
			) {
				const shouldCheckMandatory = this.requirement?.isAttachmentMandatory;
				if (shouldCheckMandatory && this.requirementResponseData?.attach.length < 1) {
					return false;
				}
			}

			if (
				!this.isTableDisplay() &&
				this.modalType === this.$requirementResponseModalType.clientValidation &&
				(!this.isScoreValid(this.requirementResponseData, this.configurations) ||
					!this.isValidityTypeDateValid(this.requirement, this.requirementResponseData))
			) {
				return false;
			}

			if (this.loadingValidation) return false;
			if (this.showUserConfirmCheckbox && !this.requirementResponseData?.userConfirm) {
				return false;
			}

			let ok = this.areQuestionAnswersValid(verifier);
			let internQuestions = this.mappedQuestionsWithConditions;
			if (!ok) {
				return false;
			}

			for (let index = 0; index < this.requirementResponseCrudStructure.length; index++) {
				const field = this.requirementResponseCrudStructure[index];
				if (field.validation) {
					ok = field.validation.rule(this.requirementResponseData[field.name]);
					if (!ok) {
						break;
					}
				}
			}

			if (!this.isTableDisplay() && internQuestions && !this.requirement.isIntegration) {
				for (let index = 0; index < this.questions.length; index++) {
					const question = this.questions[index];

					this.$nextTick(() => {
						let kQuestionResponseRef = this.$refs[`response-question-${question.idQuestion}`];
						if (kQuestionResponseRef) {
							let kQuestionResponse = kQuestionResponseRef.length > 0 ? kQuestionResponseRef[0] : null;
							if (kQuestionResponse) {
								ok = kQuestionResponse.validateOk();
								if (!ok) {
									return;
								}
							} else {
								return false;
							}
						} else {
							return false;
						}
					});
				}
			}
			return ok && this.allFieldsValid;
		},
		validateReevaluate: function () {
			if (
				this.requirementResponseData.observation == null ||
				this.requirementResponseData.observation === "" ||
				(typeof this.requirementResponseData.observation === "string" &&
					this.requirementResponseData.observation.trim() === "")
			) {
				return false;
			}
			return true;
		},
		validatePartial() {
			if (
				!this.isScoreValid(this.requirementResponseData, this.configurations) ||
				!this.validateCrudFields(this.requirementResponseCrudStructure, this.requirementResponseData)
			) {
				return false;
			}
			return true;
		},
		showUserConfirmCheckbox() {
			return this.displayType !== this.$displayType.TABLE && this.requirement.userConfirm;
		},
		requirementName: function () {
			return this.requirement.description ? this.requirement.description : "";
		},
		modalClass: function () {
			if (this.modalType == this.$requirementResponseModalType.anyView) {
				return "hideButtons";
			}
			return null;
		},
		okBtnText: function () {
			switch (this.modalType) {
				case this.$requirementResponseModalType.requirementResponse:
					return this.$t("buttons.save");
				case this.$requirementResponseModalType.clientValidation:
					if (this.displayType == this.$displayType.TABLE) return this.$t("buttons.save");
					return this.$t("buttons.approve");
				case this.$requirementResponseModalType.reprocess:
					return this.$t("buttons.approve");
			}
			return "";
		},
		cancelBtnText: function () {
			if (
				this.modalType == this.$requirementResponseModalType.requirementResponse ||
				(this.modalType == this.$requirementResponseModalType.clientValidation &&
					this.displayType == this.$displayType.TABLE)
			) {
				return this.$t("buttons.cancel");
			}
			return this.$t("buttons.reject");
		},
		okOnly: function () {
			return this.modalType == this.$requirementResponseModalType.reprocess;
		},
		requirementExplanation: function () {
			return this.requirement.explanation ? this.requirement.explanation : "";
		},
		requirementType: function () {
			let type = "";
			if (this.requirement.requirementType) {
				type = this.$t("commons.mandatory");
			} else {
				type = this.$t("commons.notMandatory");
			}
			return type;
		},
		requirementResponseCrudStructure() {
			let requirementResponseCrudStructure = [];

			if (this.requirement?.hasIssueDate) {
				requirementResponseCrudStructure.push({
					rowNum: 0,
					width: "12",
					name: "issueDate",
					label: this.$t("commons.issueDate"),
					placeholder: this.$t("commons.placeholders.dayMonthYear"),
					type: "text",
					mask: "##/##/####",
					validation: this.$validations.dateValidateNotRequired,
					isActive: () => {
						return this.modalType == this.$requirementResponseModalType.requirementResponse;
					}
				});
			}

			if (
				this.configurations?.AllowScore &&
				this.modalType === this.$requirementResponseModalType.anyView &&
				this.requirementResponseData?.scoreValue
			) {
				requirementResponseCrudStructure.push({
					rowNum: 1,
					width: "12",
					name: "scoreValue",
					label: this.$t("commons.score"),
					type: "text",
					isActive: () => {
						return this.modalType !== this.$requirementResponseModalType.anyView;
					}
				});
			}

			if (this.showUserConfirmCheckbox) {
				requirementResponseCrudStructure.push({
					rowNum: 4,
					width: "12",
					name: "userConfirm",
					label: this.$t("commons.userConfirm"),
					type: "checkbox",
					isActive: () => {
						return this.modalType == this.$requirementResponseModalType.requirementResponse;
					}
				});
			}

			let isObservationVisible = true;
			if (
				this.modalType != this.$requirementResponseModalType.clientValidation &&
				(this.requirementResponseData.observation == null || this.requirementResponseData.observation == "")
			) {
				isObservationVisible = false;
			}

			if (!this.isTableDisplay()) {
				requirementResponseCrudStructure.push({
					rowNum: 13,
					width: "12",
					label: this.$t("commons.observation"),
					name: "observation",
					placeholder: this.$t("commons.observation"),
					type: "textArea",
					isVisible: isObservationVisible,
					isActive: () => {
						return this.modalType == this.$requirementResponseModalType.clientValidation;
					}
				});
			}

			if (
				this.configurations?.AllowScore &&
				this.modalType == this.$requirementResponseModalType.clientValidation &&
				!this.isTableDisplay()
			) {
				this.$setMinMax(0, 10);
				requirementResponseCrudStructure.push({
					rowNum: 12,
					width: "12",
					label: this.$t("modals.responseRequirement.inputScoreZeroToTen"),
					name: "scoreValue",
					type: "number",
					min: 0,
					max: 10,
					validation: this.$validations.number,
					isActive: () => {
						return this.modalType !== this.$requirementResponseModalType.anyView;
					}
				});
			}

			if (
				this.requirement?.validityType == this.$ValidityType.Date &&
				this.modalType == this.$requirementResponseModalType.clientValidation &&
				!this.isTableDisplay()
			) {
				requirementResponseCrudStructure.push({
					rowNum: 14,
					width: "12",
					name: "validityDate",
					label: this.$t("modals.responseRequirement.inputValidityDate"),
					placeholder: this.$t("commons.placeholders.dayMonthYear"),
					type: "text",
					mask: "##/##/####",
					validation: this.$validations.dateValidateRequired,
					isActive: () => {
						return this.modalType !== this.$requirementResponseModalType.anyView;
					}
				});
			}

			return requirementResponseCrudStructure;
		}
	},
	watch: {
		mappedQuestionsWithConditions: {
			handler() {
				this.$nextTick(() => (this.allFieldsValid = this.validadeAllRefs()));
			},
			deep: true
		}
	},
	methods: {
		...mapActions([
			"getInvite",
			"getDocumentRequirement",
			"getIntegrationById",
			"createOrUpdateRequirementResponse",
			"getRequirementResponse",
			"getRequirementWithInactivatedQuestions",
			"uploadFileRequirementResponse",
			"getDocumentRequirementResponse",
			"updateRequirementResponseWorkflow",
			"getRequirementResponseScoreByRequirement",
			"downloadRequirementResponseDocument",
			"downloadRequirementDocument",
			"cancelInvite",
			"reprocessIntegration",
			"getRequirementQuestion",
			"getAddressByCEP",
			"getRequirementAttaches",
			"getRequirementResponseConditionList",
			"getIntegrationRequirementResponse",
			"getAllRequirementQuestionListByClient",
			"getConfigurationByClient"
		]),
		...mapMutations([
			"setDocumentRequirementResponseOnState",
			"setIntegrationOnState",
			"cleanIntegrationRequirementResponse"
		]),
		mapRequirementDate: function (date) {
			if (!date) return null;
			let mappedDate = `${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`;
			return mappedDate;
		},
		handleFieldChange: async function () {
			this.mappedQuestionsWithConditions = await this.mapQuestionsWithConditions();
			this.$nextTick(() => (this.allFieldsValid = this.validadeAllRefs()));
		},
		generatePDF() {
			const doc = new jsPDF();
			let titleAdded = false;
			let currentPage = 1;
			let yPos = 10;
			const pageHeight = doc.internal.pageSize.getHeight();

			function addText(text, isBold = false, isObjectTitle = false, isArrayTitle = false) {
				if (isBold) {
					doc.setFont("helvetica", "bold");
				} else {
					doc.setFont("helvetica", "normal");
				}
				if (isObjectTitle) {
					doc.setFontSize(12);
				} else if (isArrayTitle) {
					doc.setFontSize(10);
				} else {
					doc.setFontSize(8);
				}

				if (yPos > pageHeight - 20) {
					doc.addPage();
					currentPage++;
					yPos = 10;
				}

				doc.text(text, 10, yPos);
				yPos += 10;
			}

			const addTitleOnFirstPage = () => {
				if (currentPage === 1 && !titleAdded) {
					doc.setFontSize(16);
					doc.text(this.$t("modals.responseRequirement.completeQueryInformation"), 10, 10);
					yPos += 10; // Incremento para a próxima linha após o título
					titleAdded = true;
				}
			};

			const addJsonObject = (obj) => {
				addTitleOnFirstPage();
				Object.entries(obj).forEach(([key, value]) => {
					let translatedText = this.translateKey(key);
					if (Array.isArray(value)) {
						addText(translatedText, true, false, true);
						value.forEach((item) => {
							if (typeof item != "object" && typeof item == "string") {
								addText(item);
							} else {
								addJsonObject(item);
							}
						});
					} else if (typeof value === "object") {
						addText(translatedText, true, true, false);
						addJsonObject(value);
					} else {
						let translatedValue = this.translateKey(value);
						addText(`${translatedText}: ${translatedValue.startsWith("commons") ? value : translatedValue}`);
					}
				});
			};

			addJsonObject(this.integrationRequirementResponse);

			for (let i = 1; i <= currentPage; i++) {
				doc.setPage(i);
				doc.setFontSize(6);
				doc.setFont("helvetica", "normal");
				doc.text(`Página ${i} de ${currentPage}`, 10, pageHeight - 10);
			}

			doc.save("Consultation_Information.pdf");
		},
		translateKey: function (key) {
			return this.$t(`commons.integrationConsultations.${key}`);
		},
		handleBlur: function (obj) {
			let field = obj.field;
			let question = obj.question;
			if (field && field.label && field.label.substring(3) == "CEP *") this.handleBlurCEP(question);
		},
		handleBlurCEP: function (question) {
			let cepAnswer = this.requirementQuestionData
				.find((answer) => answer.idQuestion == question.idQuestion)
				.answer.replace("-", "");
			let needComplement = ["Cidade", "Pais", "Estado", "Bairro", "Endereço", "Complemento"];
			//Buscar o endereço no preenchimento do CEP
			if (cepAnswer.length == 8) {
				this.getAddressByCEP(cepAnswer).then((response) => {
					if (response.erro) {
						this.$functions.displayError(this, this.$t("modals.responseRequirement.error.invalidZipCode"));
					} else {
						//Preencher os campos relativos com o endereço obtido
						this.questions.forEach((question) => {
							if (needComplement.indexOf(question.linkedTo) != -1) {
								switch (question.linkedTo) {
									case "Cidade":
										this.requirementQuestionData.find((answer) => answer.idQuestion == question.idQuestion).answer =
											response.localidade;
										break;
									case "Pais":
										this.requirementQuestionData.find((answer) => answer.idQuestion == question.idQuestion).answer =
											"Brasil";
										break;
									case "Estado":
										this.requirementQuestionData.find((answer) => answer.idQuestion == question.idQuestion).answer =
											response.uf;
										break;
									case "Bairro":
										this.requirementQuestionData.find((answer) => answer.idQuestion == question.idQuestion).answer =
											response.bairro;
										break;
									case "Endereço":
										this.requirementQuestionData.find((answer) => answer.idQuestion == question.idQuestion).answer =
											response.logradouro;
										break;
									case "Complemento":
										this.requirementQuestionData.find((answer) => answer.idQuestion == question.idQuestion).answer ==
										null
											? ""
											: question.idQuestion.answer;
										break;
									default:
										break;
								}
							}
						});
					}
				});
			} else {
				this.$functions.displayError(this, this.$t("modals.responseRequirement.error.invalidZipCode"));
			}
		},

		downloadResponseFile: function (fileId) {
			this.downloadRequirementResponseDocument(fileId);
		},
		downloadRequirementFile: function (fileId) {
			this.downloadRequirementDocument(fileId);
		},
		goToSite: function (url) {
			window.location = url;
		},
		uploadFiles(event) {
			const filesArray = Array.from(event.target.files);
			const currentLocalFiles = (this.localFilesMap[this.responseIndex] || []).slice();

			for (let j = 0; j < filesArray.length; j++) {
				const file = filesArray[j];
				this.validateFile = Vue.prototype.$functions.validateFileProperties(file, this);

				if (this.validateFile) {
					currentLocalFiles.push(file);
				}
			}

			this.$set(this.localFilesMap, this.responseIndex, currentLocalFiles);
			this.updateAttachArray();
			this.localFilesListKey++;
			this.$forceUpdate();

			this.$refs.uploadInput.value = "";
		},
		triggerUpload: function () {
			this.$refs.uploadInput.click();
		},
		addFileInput: function () {
			this.fileInputs.push("");
		},
		removeLocalFile(index) {
			const files = (this.localFilesMap[this.responseIndex] || []).slice();
			if (files.length > index) {
				files.splice(index, 1);
				this.$set(this.localFilesMap, this.responseIndex, files);
				this.updateAttachArray();
				this.localFilesListKey++;
				this.$forceUpdate();
			}
			this.$refs.uploadInput.value = "";
		},
		updateAttachArray() {
			this.requirementResponseData.attach = [
				...(this.fileName || []),
				...(this.localFilesMap[this.responseIndex] || [])
			];
		},
		removeFileInput: function (index) {
			if (this.fileName[index].idDocument) {
				this.deletedFilesId.push(this.fileName[index].idDocument);
			}
			if (this.fileInputs.length > 1) {
				this.fileInputs.pop();
			}
			this.fileName.splice(index, 1);
			this.requirementResponseData.attach.splice(index, 1);
			this.deletedFilesId = this.deletedFilesId.filter((id) => id);
			document.getElementById("upload-file").value = "";
		},
		getProperties: function (item) {
			let notIncludedIntegrationArrayProps = ["urlProof", ...noIncludedItegrationProps];
			return Object.keys(item)
				.filter((key) => notIncludedIntegrationArrayProps.indexOf(key) == -1)
				.filter((ip) => item[ip] !== "");
		},
		clearModalData: function () {
			this.requirementResponseData = {
				issueDate: null,
				validityDate: null,
				answer: null,
				identifier: null,
				userConfirm: null,
				attach: [],
				scoreValue: 0,
				observation: null,
				description: null
			};

			if (this.integrationProps) {
				this.setIntegrationOnState([]);
			}
			if (this.integrationRequirementResponseProps) {
				this.cleanIntegrationRequirementResponse();
			}
			this.requirementResponseData.observation = null;
			this.requirementQuestionData = [];
			this.questions = [];
			this.tableAnswersToEdit = [];
			this.loadingValidation = true;
		},
		async setContextRequirement(contextRequirementDetails) {
			this.modalType = contextRequirementDetails.modalType;
			this.idInvite = contextRequirementDetails.idInvite;
			this.idRequirement = contextRequirementDetails.idRequirement;
			this.reprocess = contextRequirementDetails.reprocess;
			this.netrinMessageError = contextRequirementDetails.netrinError;
			this.idStep = contextRequirementDetails.idStep;
			this.idClient = contextRequirementDetails.idClient ?? this.actualUser.idClient;
			this.isFillerValidatorOnReevaluation = contextRequirementDetails.isFillerValidatorOnReevaluation;
			this.isValidateActor = contextRequirementDetails.isValidateActor;
			this.displayType = contextRequirementDetails.displayType;
			this.tableAnswersToEdit = contextRequirementDetails.answers;

			const input = {
				idInvite: contextRequirementDetails.idInvite,
				idRequirement: contextRequirementDetails.idRequirement
			};

			await this.getRequirementWithInactivatedQuestions(input);

			if (!this.isTableDisplay()) {
				const configurationObj = {
					idClient: this.idClient,
					configurationNameList: ["PartialSaving", "AllowScore"]
				};
				await this.getConfigurationByClient(configurationObj);
			}

			// Caso seja visualização do requisito, exibir opções inativas também
			this.questions =
				this.modalType == this.$requirementResponseModalType.requirementResponse
					? this.requirementWithInactivatedQuestions.questions.filter((q) => q.formType == this.$FormType.FillerForm)
					: this.modalType == this.$requirementResponseModalType.anyView
					? this.requirementWithInactivatedQuestions.questions
					: this.requirementWithInactivatedQuestions.questions.filter((q) => q.isActive);

			await this.setRequirement(
				input,
				this.displayType == this.$displayType.TABLE ? contextRequirementDetails.index : 0
			);
			await this.getRequirementResponseConditionList(input);
			const questionFilter = { idClient: this.idClient, onlyActiveQuestions: false, includeAlternatives: true };
			await this.getAllRequirementQuestionListByClient(questionFilter);

			if (
				this.requirementResponseConditionList.showAlertCondition &&
				this.modalType === this.$requirementResponseModalType.requirementResponse
			)
				this.$functions.displayWarning(this, this.$t("messages.requirementConditionsWithoutResponse"));

			this.loadingValidation = false;
			this.mappedQuestionsWithConditions = await this.mapQuestionsWithConditions();
			setTimeout(() => (this.allFieldsValid = this.validadeAllRefs()), 100);
		},
		async setRequirement(input, responseIndex) {
			this.responseIndex = responseIndex;
			this.requirementResponseData.issueDate = null;
			this.requirementResponseData.validityDate = null;
			this.requirementResponseData.answer = null;
			this.requirementResponseData.identifier = null;
			this.requirementResponseData.userConfirm = null;
			this.fileName = [];
			this.requirementResponseData.attach = [];
			this.requirementResponseData.observation = null;
			this.requirementQuestionData = [];

			if (!this.requirement) return;
			this.requirementQuestionData = this.buildDefaultRequirementQuestionData(this.questions, responseIndex ?? 0);
			if (this.displayType !== this.$displayType.TABLE) {
				await this.getRequirementResponse(input);
			}
			await this.setRequirementResponse(input);

			if (this.requirement.isIntegration) {
				this.getInvite({ idInvite: this.idInvite }).then((invite) => {
					this.getIntegrationById({
						idIntegration: this.requirement.idIntegration,
						idSupplier: invite.supplier.idSupplier
					});

					if (this.includedIntegrationRequirementResponse == this.requirement.idIntegration) {
						this.getIntegrationRequirementResponse({
							idRequirement: this.requirement.idRequirement,
							idIntegration: this.requirement.idIntegration,
							idInvite: input.idInvite
						});
					}
				});
			}
			if (this.requirement.fileId) {
				await this.getDocumentRequirement(this.requirement.fileId);
			}
		},
		async setRequirementResponse() {
			if (!this.requirementResponse) return;

			this.type = "update";
			if (this.displayType !== this.$displayType.TABLE) {
				this.requirementResponseData.status = this.requirementResponse.status;
				this.requirementResponseData.issueDate = this.requirementResponse.issueDate;
				this.requirementResponseData.observation = this.requirementResponse.observation;
				this.requirementResponseData.answer = this.requirementResponse.answer;
				this.requirementResponseData.scoreValue = this.requirementResponse.scoreValue;
				this.requirementResponseData.identifier = this.requirementResponse.identifier;
				this.requirementResponseData.observation = this.requirementResponse.observation;
				this.requirementResponseData.userConfirm = this.requirementResponse.userConfirm;
				if (this.requirementResponse.attach) {
					await this.getDocumentRequirementResponse(this.requirementResponse.attach);
					let atch = {
						idInvite: this.requirementResponse.idInvite,
						idDocument: this.requirementResponse.attach,
						name: this.documentRequirementResponse.name
					};

					this.requirementResponseData.attach.push(atch);
					this.fileName = [atch];
					this.fileInputs = [atch.name];
					this.fileInputs.splice(1);
					this.filesListKey++;
				}
				let obj = {
					idRequirement: this.requirementResponse.idRequirement,
					idInvite: this.requirementResponse.idInvite,
					responseIndex: this.responseIndex
				};
				let attaches = await this.getRequirementAttaches(obj);
				if (attaches.length > 0) {
					attaches.forEach((atch, index) => {
						this.requirementResponseData.attach.push(atch);
						this.fileName[index] = atch;
						this.fileInputs[index] = atch.name;
						this.fileInputs.splice(attaches.length);
						this.filesListKey++;
					});
				} else {
					this.fileInputs = [""];
				}
			}

			if (this.displayType === this.$displayType.TABLE && this.tableAnswersToEdit) {
				for (let index = 0; index < this.requirementQuestionData.length; index++) {
					const answerData = this.tableAnswersToEdit.find(
						(qa) => qa.idQuestion == this.requirementQuestionData[index].idQuestion
					);

					if (answerData) {
						if (answerData.responseType === this.$ResponseType.StandardList) {
							let foundAlternative = null;

							this.questions.forEach((question) => {
								const alternative = question.standardListAlternatives.find(
									(alt) => alt.idAlternative == answerData.answer
								);
								if (alternative) {
									foundAlternative = alternative;
								}
							});

							this.requirementQuestionData[index].description = answerData.description
								? answerData.description
								: foundAlternative?.description;
						}

						this.requirementQuestionData[index].answer = answerData.answer;
						this.requirementQuestionData[index].justification = answerData.justification;
					}
				}

				try {
					const input = {
						idInvite: this.idInvite,
						idRequirement: this.idRequirement,
						responseIndex: this.responseIndex
					};

					const attaches = await this.getRequirementAttaches(input);
					if (attaches?.length) {
						const localFiles = this.localFilesMap[this.responseIndex] || [];
						this.requirementResponseData.attach = [...attaches, ...localFiles];
						this.fileName = [...attaches];
						this.localFiles = [...localFiles];
						this.fileInputs = [...attaches.map((file) => file.name), ...localFiles.map((file) => file.name)];
						this.filesListKey++;
					} else {
						const localFiles = this.localFilesMap[this.responseIndex] || [];
						this.requirementResponseData.attach = [...localFiles];
						this.localFiles = [...localFiles];
						this.fileInputs = [...localFiles.map((file) => file.name)];
					}
				} catch (e) {
					console.error("Erro ao buscar attaches:", e);
				}
			}

			const shouldApplyRequirementResponse =
				this.requirementResponse && (!this.tableAnswersToEdit || this.displayType !== this.$displayType.TABLE);
			if (shouldApplyRequirementResponse) {
				this.applyRequirementResponseToQuestionData({
					questionDataList: this.requirementQuestionData,
					questions: this.questions,
					showFieldUpdateWarning: this.modalType == this.$requirementResponseModalType.requirementResponse
				});
			}
			this.requirementResponseData.validityDate = this.mapRequirementDate(this.requirementResponse.validityDate);
		},
		reprocessEvent() {
			let reprocessInput = {
				idInvite: this.idInvite,
				idRequirement: this.idRequirement
			};

			this.reprocessIntegration(reprocessInput).then((success) => {
				if (success) {
					this.$functions.displaySuccess(this, this.$t("modals.responseRequirement.reprocessIntegrationSuccessfully"));
					this.$emit("closeModal");
				} else {
					this.$functions.displayError(this, this.$t("modals.responseRequirement.reprocessIntegrationFailed"));
					this.$emit("closeModal");
				}
			});
			this.$bvModal.hide("responseRequirementModal");
		},
		okEvent(isPartialAnswer) {
			const closeModal = () => {
				this.$bvModal.hide("responseRequirementModal");
				this.$emit("closeModal");
			};

			if (
				(this.modalType == this.$requirementResponseModalType.clientValidation && !this.isTableDisplay()) ||
				this.modalType == this.$requirementResponseModalType.reprocess
			) {
				const hasValidationForm = this.questions.some((q) => q.formType === this.$FormType.ValidationForm);

				if (isPartialAnswer) {
					this.saveChanges(isPartialAnswer).then(closeModal);
				} else {
					const savePromise = hasValidationForm ? this.saveChanges(isPartialAnswer) : Promise.resolve();

					savePromise.then(() => this.approveRequirement(this.isTableDisplay(), isPartialAnswer)).then(closeModal);
				}
			} else {
				if (this.isTableDisplay()) {
					this.$emit("saveAnswer", {
						requirementQuestionData: this.requirementQuestionData.map((question) => ({
							...question,
							requirementStatus: isPartialAnswer
								? this.$RequirementStatus.PartialAnswer
								: this.$RequirementStatus.InProgress
						})),
						deletedFilesId: this.deletedFilesId,
						attach: this.requirementResponseData.attach,
						fileName: this.fileName,
						addedFile: this.addedFile,
						scoreValue: this.requirementResponseData.scoreValue,
						observation: this.requirementResponseData.observation,
						validityDate: this.requirementResponseData.validityDate
					});
					this.$bvModal.hide("responseRequirementModal");
				} else {
					this.saveChanges(isPartialAnswer).then(() => {
						this.clearLocalFiles(this.responseIndex);
						closeModal();
					});
				}
			}
		},
		clearLocalFiles(responseIndex = null) {
			this.localFiles = [];
			if (responseIndex === null) {
				this.localFilesMap = {};
			} else {
				this.localFilesMap[responseIndex] = [];
			}
			this.localFilesListKey++;
			this.filesListKey++;
		},
		cancelEvent: function () {
			this.$bvModal.hide("responseRequirementModal");
			if (
				(!this.isTableDisplay() && this.modalType == this.$requirementResponseModalType.clientValidation) ||
				this.modalType == this.$requirementResponseModalType.reprocess
			) {
				//Caso o requisito seja obrigatório, cancelar automaticamente o convite
				if (this.requirement.requirementType) {
					this.excluirModal(this.modalCancelConfirmConfigs).OK(() => {
						let cancelInviteObj = {
							IdInvite: this.idInvite,
							currentIdStep: this.idStep,
							nextStepMessage: this.messageAction
						};
						this.refuseRequirement(false).then(() => {
							this.$emit("closeModal");
							this.cancelInvite(cancelInviteObj).then(
								() => {
									this.$functions.displaySuccess(this, this.$t("messages.inviteCanceledSuccessfully"));
									this.$router.push({
										name: "enterpriseList",
										params: {}
									});
								},
								(error) => {
									this.$functions.displayError(
										this,
										this.$t("messages.inviteCancelationFail") + "\n" + error.response.data.error.message
									);
								}
							);
						});
					});
				} else {
					this.refuseRequirement(true).then(() => {
						this.$emit("closeModal");
					});
				}
			}
			this.clearLocalFiles();
		},
		isTableDisplay() {
			return this.displayType === this.$displayType.TABLE;
		},
		formatDate: function (date) {
			if (!date) return null;

			if (date.split("/").length == 1) {
				return date;
			}
			let splittedDate = date.split("/");
			let formattedDate = splittedDate[2] + "-" + splittedDate[1] + "-" + splittedDate[0] + "T00:00:00";

			return formattedDate;
		},
		mapValidityToBack: function (objFilter) {
			if (objFilter.validityDate != null) {
				let format = this.formatDate(objFilter.validityDate);
				if (format === null) {
					delete objFilter.validityDate;
				} else {
					objFilter.validityDate = format;
				}
			}
		},
		reevaluateEvent: function () {
			if (this.modalType != this.$requirementResponseModalType.clientValidation) return;

			if (
				this.requirementResponseData.observation == null ||
				this.requirementResponseData.observation === "" ||
				(typeof this.requirementResponseData.observation === "string" &&
					this.requirementResponseData.observation.trim() === "")
			) {
				this.$functions.displayWarning(this, this.$t("modals.responseRequirement.reevaluationMandatoryObservation"));
				return;
			}
			this.reevaluateRequirement().then(() => {
				this.$bvModal.hide("responseRequirementModal");
				this.$emit("closeModal");
			});
		},
		refuseRequirement: function (shouldShowAlert) {
			return new Promise((resolve) => {
				let score =
					this.requirementResponseData.scoreValue === "" ||
					parseInt(this.requirementResponseData.scoreValue) < 0 ||
					parseInt(this.requirementResponseData.scoreValue) > 10
						? false
						: true;
				let input = {
					idInvite: this.idInvite,
					idRequirement: this.idRequirement,
					status: this.$RequirementStatus.Rejected,
					scoreValue: score ? this.requirementResponseData.scoreValue : 0,
					observation: this.requirementResponseData.observation,
					validityDate: this.requirementResponseData.validityDate
				};
				this.mapValidityToBack(input);
				this.updateRequirementResponseWorkflow(input).then(
					() => {
						if (shouldShowAlert) {
							this.$functions.displaySuccess(
								this,
								this.$t("modals.responseRequirement.requirementRejectedSuccessfully")
							);
						}
						this.requirementResponseData.scoreValue = null;
						this.requirementResponseData.validityDate = null;
						resolve();
					},
					(error) => {
						if (error.code) this.$functions.displayError(this, this.$t(error.code, error.metadata));
						else
							this.$functions.displayError(
								this,
								this.$t("modals.responseRequirement.requirementRejectError") + "\n" + error
							);
					}
				);
			});
		},
		approveRequirement: function (isTableDisplay) {
			return new Promise((resolve, reject) => {
				let input = {
					idInvite: this.idInvite,
					idRequirement: this.idRequirement,
					status: this.$RequirementStatus.Accepted,
					scoreValue: this.requirementResponseData.scoreValue,
					observation: this.requirementResponseData.observation,
					validityDate: this.requirementResponseData.validityDate
				};
				let allOk = this.$refs.requirementCRUD.validateAllFields();
				if (allOk) {
					this.mapValidityToBack(input);
					this.updateRequirementResponseWorkflow(input).then(
						() => {
							const successMessage = isTableDisplay
								? this.$t("messages.savedChanges")
								: this.$t("modals.responseRequirement.requirementApprovedSuccessfully");
							this.$functions.displaySuccess(this, successMessage);
							resolve();
						},
						(error) => {
							const errorMessage = isTableDisplay
								? this.$t("messages.changesCouldNotBeSaved")
								: this.$t("modals.responseRequirement.approveRequirementError");
							this.$functions.displayError((this, errorMessage) + error);
							reject();
						}
					);
				} else {
					this.$functions.displayError(this, this.$t("modals.responseRequirement.verifyRequirements"));
					reject();
				}
			});
		},
		reevaluateRequirement: function () {
			return new Promise((resolve) => {
				let input = {
					idInvite: this.idInvite,
					idRequirement: this.idRequirement,
					status: this.$RequirementStatus.InReevaluation,
					scoreValue: this.requirementResponseData.scoreValue,
					observation: this.requirementResponseData.observation,
					validityDate: this.requirementResponseData.validityDate
				};
				this.mapValidityToBack(input);
				this.updateRequirementResponseWorkflow(input).then(
					() => {
						this.$functions.displaySuccess(
							this,
							this.$t("modals.responseRequirement.requirementToReevaluationSuccessfully")
						);
						this.requirementResponseData.scoreValue = null;
						this.requirementResponseData.validityDate = null;
						resolve();
					},
					(error) => {
						if (error.code) this.$functions.displayError(this, this.$t(error.code, error.metadata));
						else
							this.$functions.displayError(
								this,
								this.$t("modals.responseRequirement.requirementoReevaluationError") + "\n" + error
							);
					}
				);
			});
		},
		saveChanges(isPartialAnswer) {
			return new Promise((resolve) => {
				const { isValid, payload } = this.buildQuestionAnswerPayload({
					isPartialAnswer,
					additionalData: {
						...this.requirementResponseData,
						deletedFilesId: this.deletedFilesId || []
					}
				});

				if (!isValid) {
					resolve(false);
					return;
				}

				this.mapValidityToBack(payload);
				const localFiles = this.localFilesMap[this.responseIndex] || [];
				payload.attach = localFiles.map((file) => ({
					file,
					responseIndex: this.responseIndex
				}));

				const hasNewFile = payload.attach.some((attach) => !attach.file.idInvite);

				if (localFiles.length > 0 && hasNewFile && !this.isFillerValidatorOnReevaluation) {
					if (hasNewFile) {
						this.uploadFileRequirementResponse(payload)
							.then(() => this.createOrUpdateRequirementResponse(payload))
							.then(() => {
								this.$functions.displaySuccess(this, this.$t("messages.updatedSuccessfully"));
								resolve();
							})
							.catch(() => {
								this.$functions.displayError(this, this.$t("messages.fileError.noProcessFile"));
							});
					} else {
						this.createOrUpdateRequirementResponse(payload)
							.then(() => {
								this.$functions.displaySuccess(this, this.$t("messages.updatedSuccessfully"));
								resolve();
							})
							.catch(() => {
								this.$functions.displayError(this, this.$t("modals.responseRequirement.attachFileError"));
							});
					}
				} else {
					this.createOrUpdateRequirementResponse(payload)
						.then((response) => {
							if (response.inviteWasCanceled) {
								this.$functions.displayWarning(this, this.$t("messages.invitationCanceled"));
							} else {
								this.$functions.displaySuccess(this, this.$t("messages.updatedSuccessfully"));
							}

							if (response.refreshRegistrationData) {
								this.$emit("refreshRegistrationData", {
									shouldRefresh: true
								});
							}
							resolve();
						})
						.catch(() => {
							this.$functions.displayError(this, this.$t("modals.responseRequirement.approveRequirementError"));
						});
				}
			});
		},
		hideEvent(event) {
			const closeWays = ["esc", "headerclose"];
			if (closeWays.includes(event.trigger)) {
				this.clearLocalFiles();
			}
		}
	}
};
</script>

<style scoped>
.basicInformations {
	width: 100%;
}
.basicInformations label {
	font-weight: bold;
	font-size: 12px;
}

.download-section {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.download-button-container {
	display: flex;
	align-items: center;
}
.separator {
	border-bottom: 1px solid rgb(219, 218, 218);
	margin-bottom: 4px;
}
.fileList {
	margin-inline: 15px;
	display: flex !important;
}
.fileList:hover {
	cursor: pointer;
	text-decoration: underline;
}
.fileList .icon {
	align-self: center;
}
.fileTitle {
	margin-left: 16px;
	color: rgb(105, 105, 105);
}
.fileLine {
	height: 30px;
	display: inline-flex;
	flex-direction: row;
	width: 100%;
}
.fileLine div {
	align-self: center;
	flex-grow: 1;
	margin-left: 16px;
}
.fileListReadOnly {
	margin-inline: 16px;
	display: flex !important;
}
.fileListReadOnly .icon {
	align-self: center;
}
.files {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.details {
	max-height: 300px;
	overflow: auto;
	padding: 0px 30px 0px 30px;
}
.textModal {
	display: flex;
}
.formatted-text-display {
	width: 75%;
	background-color: transparent;
	min-height: 40px;
	overflow: visible;
	white-space: pre-wrap;
	word-wrap: break-word;
}
</style>

<style>
#responseRequirementModal___BV_modal_footer_ .btn-primary {
	background-color: #19b600;
	border-color: #19b600;
}
#responseRequirementModal___BV_modal_footer_ .btn-secondary {
	background-color: #ff0000;
	border-color: #ff0000;
}

.hideButtons #responseRequirementModal___BV_modal_footer_ .btn-primary {
	display: none;
}
.hideButtons #responseRequirementModal___BV_modal_footer_ .btn-secondary {
	display: none;
}

.modalPadding {
	padding: 0px 30px 0px 30px;
}
</style>
